import { Col, Row, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Panel from '../../../../../shared/components/card/Panel';
import { APPID, authFeatureConstants, GUTTOR_SPACE, TOOLTIP_TEXT } from '../../../../../shared/constants/commonConstants';
import SaveHospitalDetails from '../../../profile/details/hospitalDetails/SaveHospitalDetails';
import HospitalDetail from './HospitalDetail';
import { fetchHospitalLogo } from './../../../../../store/actions/hospitalAction';
import _ from 'lodash';
import { ReactComponent as EditIcon } from '../../../../../assets/images/svg/i_edit.svg';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/svg/i_close.svg';
import { canActivate } from '../../../../../utils/utility';
import {decryptText} from '../../../../../utils/encryptDecrypt';

const HospitalDetails = (): ReactElement => {

  const [profileDetail, setProfileDetailHandler] = useState(null as any);
  const hospitalProfileData = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);
  const hospitalLogoBytes = useSelector(({ hospital: { hospitalLogo } }: any): any => hospitalLogo);
  const ref = useRef({ isDataLoaded: false });
  const [showSaveComponent, setShowSaveComponent] = useState(Boolean);
  const [imageUrl, setImageUrl] = useState('');
  const [supremeData, setSupremeData] = useState(null as any);
  const dispatch = useDispatch();
  const isNewEntry = useSelector(
    ({ hospital: { newEntry } }: any): any => newEntry,
  );
  useEffect((): void => {
    if (hospitalProfileData) {
      setShowSaveComponent(false);
      ref.current.isDataLoaded = true;
      fetchProfileDetail();
    }
    if (!hospitalProfileData) {
      const data = JSON.parse(decryptText(localStorage.getItem('providerDetail') || '{}') as any);
      if (data) {
        setSupremeData({
          fullName: data.providerName,
          displayName: data.providerName,
          description: data.providerDescription,
          emailId: data.providerEmailAddress,
          website: data.providerWebsite,
          landlineNumber: data.providerMobileNumber,
          supportNumber: data.providerMobileNumber,
          pincode: data.providerPinCode,
          state: data.providerState,
          city: data.providerCity,
          streetAddress: data.providerAddress,
          latitude: data.providerLatitude,
          longitude: data.providerLongitude,
          rohiniId: data.providerRohiniCode,
          providerId: data.providerId,
          supremeId: data.providerId,
        });
      }
    }

    // eslint-disable-next-line
  }, [hospitalProfileData]);

  useEffect((): void => {
    if (hospitalLogoBytes) {
      setImageUrl(hospitalLogoBytes.fileBytes);
    }
  }, [hospitalLogoBytes]);

  const fetchProfileDetail = async (): Promise<any> => {
    if (hospitalProfileData) {
      setProfileDetailHandler(hospitalProfileData[0]);
      const response = hospitalProfileData[0]?.documentDetails.filter((doc: any): boolean => doc.typeName === 'Logo');
      if (response && response.length > 0 && response[0].docId) {
        getFileBytes(_.orderBy(response, 'id', 'desc')[0].docId);
      }
    }
  };

  const getFileBytes = async (docId: number): Promise<void> => {
    const request = {
      applicationId: APPID,
      fileIdentifiers: [docId],
    };
    dispatch(fetchHospitalLogo(request));
  };

  const handleEdit = (): void => {
    if (profileDetail) {
      ref.current.isDataLoaded = false;
      setShowSaveComponent(!showSaveComponent);
    }
  };

  return (
    <div>
      <Row gutter={GUTTOR_SPACE}>
        <Col span={24}>
          <Panel title="Hospital Details"
            extra={(!isNewEntry && canActivate(authFeatureConstants.EDIT_HOSPITAL_PROFILE)) &&
              <a onClick={(e: any): any => handleEdit()} >
                {(!showSaveComponent && !_.isEmpty(profileDetail)) ?
                  <Tooltip title={TOOLTIP_TEXT.edit}><EditIcon className="fill-primary" /></Tooltip> :
                  <Tooltip title={TOOLTIP_TEXT.close}><span className="error-text">
                    <CloseIcon className="fill-close" /></span></Tooltip>}
              </a>}  >
            {(!showSaveComponent && !isNewEntry) &&
              <HospitalDetail profileDetail={profileDetail} imgUrl={imageUrl} />
            }
            {(showSaveComponent || isNewEntry) &&
              <SaveHospitalDetails data={profileDetail ? profileDetail : supremeData} onCancel={handleEdit} imgUrl={imageUrl} />
            }
          </Panel>
        </Col>
      </Row>
    </div >
  );
};

export default HospitalDetails;
